import { Title, Text, Stack, Paper } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PortalButton } from 'components/Button/PortalButton';
import { BsListUl, BsShieldLockFill } from 'react-icons/bs';
import { RecoveryCodesForm } from 'pages/Profile/TwoStepAuth/RecoveryCodesForm';
import { useDrawerContext } from 'context/hooks';
import { TwoStepAuthDisable } from 'pages/Profile/TwoStepAuth/TwoStepAuthDisable';
import { TwoStepAuthEnable } from 'pages/Profile/TwoStepAuth/TwoStepAuthEnable';

interface MfaCardProps {
  title: string;
  body?: string;
  enableButtonText: string;
  disableButtonText: string;
  isMfaEnabled?: boolean;
}

export const MfaCard = ({ title, body, enableButtonText, disableButtonText, isMfaEnabled }: MfaCardProps) => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();

  return (
    <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder>
      <Stack>
        <Title order={3}>{title}</Title>
        {body ?? <Text>{body}</Text>}
        {isMfaEnabled ? (
          <Stack>
            <PortalButton
              color={'red'}
              variant={'outline'}
              Icon={BsShieldLockFill}
              label={disableButtonText}
              onClick={() =>
                openDrawer({
                  content: <TwoStepAuthDisable />,
                  size: 'md',
                })
              }
            />
            <PortalButton
              variant={'outline'}
              Icon={BsListUl}
              label={t('mfa_recovery_title')}
              onClick={() =>
                openDrawer({
                  content: <RecoveryCodesForm />,
                  size: 'md',
                })
              }
            />
          </Stack>
        ) : (
          <PortalButton
            variant={'outline'}
            Icon={BsShieldLockFill}
            label={enableButtonText}
            onClick={() =>
              openDrawer({
                content: <TwoStepAuthEnable />,
                size: 'md',
              })
            }
          />
        )}
      </Stack>
    </Paper>
  );
};
